var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth"},[_c('section',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form"},[_vm._m(0),_vm._t("default")],2)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo/logo.png")}}),_c('br')])
}]

export { render, staticRenderFns }